import { toast } from 'react-toastify';

import moment from 'moment';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestCadastroCondutor({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'condutor', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteCadastroCondutor({ payload }) {
  try {
    const { cond_cpf, params } = payload;

    yield call(api.delete, `condutor/${cond_cpf}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { cadastrocondutor, params } = payload;

    yield call(api.post, 'condutor', cadastrocondutor);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/cadcondutor');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { cond_cpf } = payload;

    const { data } = yield call(api.get, `condutor/${cond_cpf}`);

    const dataMod = {
      ...data,
      datahorainicialmovimentacao: moment(
        data.datahorainicialmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
      datahorafinalmovimentacao: moment(
        data.datahorafinalmovimentacao,
        'DD/MM/YYYY HH:mm:ss',
        true
      ).format('YYYY-MM-DDTHH:mm:ss'),
    };

    yield put(successRequest(dataMod));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { cadastrocondutor, params } = payload;

    yield call(api.put, 'condutor', cadastrocondutor);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadcondutor');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'condutor', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@cadastrocondutor/CADASTROCONDUTOR_IN_REQUEST',
    requestCadastroCondutor
  ),
  takeLatest(
    '@cadastrocondutor/DELETE_CADASTROCONDUTOR',
    deleteCadastroCondutor
  ),
  takeLatest('@cadastrocondutor/SUCCESS_REMOVE', requestCadastroCondutor),
  takeLatest('@cadastrocondutor/STORE_CADASTROCONDUTOR', store),
  takeLatest('@cadastrocondutor/FIND_CADASTROCONDUTOR', find),
  takeLatest('@cadastrocondutor/UPDATE_CADASTROCONDUTOR', update),
  takeLatest('@cadastrocondutor/RECORD_FILTERING', applyedFilters),
]);
